<style scoped>
    .question-info-container {
        font-size: .7em;
    }
    .table-xs td, 
    .table-xs th {
        padding: .25em;
    }
</style>
<template>
    <div class="question-info-container dev-only" :class="{'float-right': !showQuestionInfo}">
        <div class="col-md-1" v-if="showQuestionName">
            <strong>{{ question.name }}:</strong>
        </div>
        <div class="row" v-show="showQuestionInfo">
            <div class="col-md-11">
                <div v-if="hasProgramConditions || hasResponseConditions || hasCustomCondition">
                    <table class="table table-xs table-bordered">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Condition</th>
                                <th>Program/Response value</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(values, attribute) in conditions.program" :key="attribute">
                                <td>Program</td>
                                <td>{{attribute}} == {{values}}</td>
                                <td>{{(program[attribute]) ? program[attribute] : 'NULL' }}</td>
                            </tr>
                            <tr v-for="(values, attribute) in conditions.response" :key="attribute">
                                <td>Response</td>
                                <td>{{attribute}} == {{values}}</td>
                                <td>{{(response[attribute]) ? response[attribute] : 'NULL' }}</td>
                            </tr>
                            <tr v-if="conditions.custom != ''">
                                <td>Custom</td>
                                <td colspan="2">{{ conditions.custom }}</td>
                            </tr>
                        </tbody>
                    </table>
              </div>
              <div v-else>Always show this question</div>
            </div>
        </div>
        <div>
            <strong>{{ question.name }}</strong> {{ (!visibility) ? '(hidden)' : '' }}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            response: {
                required: true,
                type: Object
            },
            conditions: {
                type: Object,
                required: true
            },
            question: {
                type: Object,
                required: true
            },
            program: {
                type: Object,
                required: true
            },
            showQuestionInfo: {
                type: Boolean,
                default: true
            },
            visibility: {
                type: Boolean
            },
            showQuestionName: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            hasProgramConditions: function () {
                return Object.keys(this.conditions.program).length > 0;
            },
            hasResponseConditions: function () {
                return Object.keys(this.conditions.response).length > 0;
            },
            hasCustomCondition: function () {
                return typeof(this.conditions.custom) == "string";
            }
        }
    }
</script>